import httpClient from './httpClient'

/**
 * Axios Interceptor to add the token in every request
 * 
 * @param token String
 * 
 */

const useInterceptor = async (token) => {

    // Config interceptor
    // https://github.com/axios/axios#interceptors

    httpClient.interceptors.request.use((config) => {

        config.headers['Authorization'] = `Bearer ${token}`
        return config

    })

    return true

}

/**
 * Get the JWT token from the API
 * 
 */

const TOKEN_END_POINT = '/authentication_token'

const getAuthToken = (username,password) => httpClient.post( TOKEN_END_POINT, { "username": username, "password": password } )

/**
 * Use the interceptor
 * 
 */

//httpClient.interceptors.request.use(authInterceptor)

export {

    getAuthToken,
    useInterceptor

}